<template>
    <div class="real-estate-agent-home">
        <home-cover
            :home-section="homeSection"
            :is-mobile="isMobile"
        />

        <home-header
            :landing-page="landingPage"
            :home-section="homeSection"
            :is-mobile="isMobile"
        />

        <b-container>
            <b-row
                v-if="isMobile"
                class="mt-5"
            >
                <b-col>
                    <home-introduction
                        :home-section="homeSection"
                    />
                </b-col>
            </b-row>

            <b-row
                class="mt-5 mb-4"
            >
                <b-col>
                    <home-menu-cards
                        :is-mobile="isMobile"
                        :landing-page="landingPage"
                    />
                </b-col>
            </b-row>

            <b-row class="d-none d-lg-block">
                <b-col>
                    <b-card-group
                        class="d-flex"
                        deck
                    >
                        <agent-contact-info-card
                            :landing-page="landingPage"
                        />
                        <home-content-card
                            :home-section="homeSection"
                        />
                    </b-card-group>
                </b-col>
            </b-row>

            <b-row class="d-none d-md-block d-lg-none">
                <b-col>
                    <b-card>
                        <b-row>
                            <b-col
                                cols="5"
                                class="text-center my-auto"
                            >
                                <home-company-logo
                                    v-if="logo"
                                    :logo-src="logo"
                                />

                                <agent-contact-info :landing-page="landingPage" />
                            </b-col>

                            <b-col cols="7">
                                <home-introduction :home-section="homeSection" />
                                <benefits :home-section="homeSection" />
                            </b-col>
                        </b-row>
                    </b-card>
                </b-col>
            </b-row>

            <b-row
                class="mt-5"
                v-if="isMobile"
            >
                <b-col class="text-center">
                    <home-company-logo
                        v-if="logo"
                        :logo-src="logo"
                    />
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
    import ShowNotificationMixin from "@milestoneslabs/milestones-ui-kit/src/mixins/ShowNotificationMixin";
    import LandingPageAppResource from "@milestoneslabs/milestones-core-js/src/AppResources/LandingPageAppResource";
    import HomeCover from "../../../../../components/LandingPage/Home/HomeCover/HomeCover";
    import HomeHeader from "../../../../../components/LandingPage/Home/HomeHeader/HomeHeader";
    import HomeMenuCards from "../../../../../components/LandingPage/Home/HomeMenuCards/HomeMenuCards";
    import IsMobileMixin from "@milestoneslabs/milestones-ui-kit/src/mixins/IsMobileMixin";
    import HomeIntroduction from "../../../../../components/LandingPage/Home/HomeIntroduction/HomeIntroduction";
    import AgentContactInfoCard from "../../../../../components/LandingPage/Home/AgentContactInfoCard/AgentContactInfoCard";
    import HomeContentCard from "../../../../../components/LandingPage/Home/HomeContentCard/HomeContentCard";
    import HomeCompanyLogo from "../../../../../components/LandingPage/Home/HomeCompanyLogo/HomeCompanyLogo";
    import Benefits from "../../../../../components/LandingPage/Home/Benefits/Benefits";
    import AgentContactInfo from "../../../../../components/LandingPage/Home/AgentContactInfo/AgentContactInfo";

    export default {
        name: "RealEstateAgent",
        components: {
            AgentContactInfo,
            Benefits,
            HomeCompanyLogo,
            HomeContentCard,
            AgentContactInfoCard,
            HomeIntroduction,
            HomeMenuCards,
            HomeHeader,
            HomeCover
        },
        mixins: [
            ShowNotificationMixin,
            IsMobileMixin,
        ],
        props: {
            landingPage: {
                type: LandingPageAppResource,
                default: () => {
                    return new LandingPageAppResource({});
                }
            }
        },
        data() {
            return {
                homeSection: this.landingPage.home,
            };
        },

        computed: {
            logo() {
                return (this.landingPage.organizationLogo || {}).publicStorageUrl || null;
            },
        },
    };
</script>
